import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const COMPANY_BY_UUID_RESOURCE = "company" as const;
export const COMPANY_BY_UUID_API_PATH = `/v1/${COMPANY_BY_UUID_RESOURCE}/{uuid}` as const;

export type CompanyByUuidParameters = paths[typeof COMPANY_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type CompanyByUuidResponse =
  paths[typeof COMPANY_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useCompanyByUuidQuery(uuid: string, options?: Options<CompanyByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<CompanyByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [COMPANY_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<CompanyByUuidResponse>(`/v1/${COMPANY_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
